/* eslint-disable react/no-did-update-set-state */
// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import classNames from 'classnames';
import _ from 'lodash';

import { setAuthError as setError } from 'client/actions';
import InputField from './InputField';
import * as css from './PhoneLogin.scss';

type Props = {
	state: string,
	phoneValue: ?string,
	handleSubmit: Function,
	setError: Function,
	onSubmit: Function,
	isBusy: boolean,
	authError: string,
	btnBgColor: string,
	btnTextColor: string,
};

const PHONE_FORM_STATE = {
	NONE: 'NONE',
	ENTER_PHONE: 'ENTER_PHONE',
	PHONE_SUBMITTED: 'PHONE_SUBMITTED',
	ENTER_CODE: 'ENTER_CODE',
	CODE_SUBMITTED: 'CODE_SUBMITTED',
};

class PhoneNumberForm extends React.Component<Props> {
	phoneInputRef: { current: ?HTMLInputElement } | null;

	constructor() {
		super();

		this.phoneInputRef = React.createRef();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.state === PHONE_FORM_STATE.ENTER_PHONE && prevProps.state === PHONE_FORM_STATE.NONE) {
			if (this.phoneInputRef && this.phoneInputRef.current) {
				this.phoneInputRef.current.focus();
			}
		}
	}

	onInputFocus = () => {
		this.props.setError('');
	};

	onSubmit = data => {
		const israelCode = '+972';
		const phoneArr = data.phone.split('');
		phoneArr.splice(0, 1);
		const phone = `${israelCode}${phoneArr.join('')}`;
		this.props.onSubmit(phone);
	};

	render() {
		const { state, phoneValue, handleSubmit, isBusy, authError, btnBgColor, btnTextColor } = this.props;

		return (
			<form
				name="phoneNumberForm"
				className={classNames(
					css.form,
					state === PHONE_FORM_STATE.PHONE_SUBMITTED && css.submitted,
					state !== PHONE_FORM_STATE.ENTER_PHONE && state !== PHONE_FORM_STATE.PHONE_SUBMITTED && css.hidden
				)}
				onSubmit={handleSubmit(this.onSubmit)}
				key="phone"
			>
				<div className={css.inputAndSubmit}>
					<InputField
						className={css.input}
						name="phone"
						onFocus={this.onInputFocus}
						size="auto"
						type="phone"
						inputRef={this.phoneInputRef}
						placeholder="הקלידו מספר טלפון"
						maxLength={10}
						authError={authError}
					/>
					<button
						id="phoneSubmit"
						type="submit"
						className={classNames(css.button, { [css.disabled]: !phoneValue }, authError && css.withError)}
						style={{ color: btnTextColor, backgroundColor: btnBgColor }}
					>
						<p>קבלת קוד אימות</p>
						{isBusy && (
							<div className={css.loader}>
								<span></span>
							</div>
						)}
					</button>
				</div>
			</form>
		);
	}
}

const PhoneNumberReduxForm = reduxForm({
	form: 'phoneNumber',
	// validate: values => {
	// 	const errors = {};

	// 	if (_.get(values, 'phone.length') < 10) {
	// 		errors.phone = 'פורמט טלפון לא חוקי';
	// 	}

	// 	return errors;
	// },
})(PhoneNumberForm);

const mapState = state => ({
	phoneValue: _.get(state, 'form.phoneNumber.values.phone'),
});

const mapDispatch = {
	setError,
};

export default connect(mapState, mapDispatch)(PhoneNumberReduxForm);
